/* eslint-disable lingui/no-unlocalized-strings */

// import { HandHeart } from "@phosphor-icons/react";
import { motion } from "framer-motion";

export const DonationBanner = () => (
  <motion.a
    href="https://acadenice.fr"
    target="_blank"
    whileHover={{ height: 48 }}
    initial={{ opacity: 0, y: -50, height: 32 }}
    animate={{ opacity: 1, y: 0, transition: { duration: 0.3 } }}
    className="hidden w-screen items-center justify-center gap-x-2 bg-primary text-xl font-normal leading-relaxed text-primary-foreground lg:flex"
  >
    {/* <HandHeart weight="bold" size={14} className="shrink-0" /> */}
    <span>
      Découvrez aussi le site d'Acadé<span className="text-[#FDA100]">Nice</span> !
    </span>
  </motion.a>
);
